import ReactMarkdown from 'react-markdown';
import {
  useState,
  useEffect,
  PropsWithChildren,
  Fragment,
  useRef
} from 'react';
import { GraphController } from 'components/Reports/GraphController';
import './MDReport.scss';
import {
  DownloadOutlined,
  FileTextFilled,
  FileTextOutlined
} from '@ant-design/icons';

const MDReport = () => {
  const [mdString, setMDString] = useState('#MD File');
  const [showEditor, setEditorVisibility] = useState(false);
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    fetch('reports/usage.md')
      .then(response => response.text())
      .then(data => {
        setMDString(data);
      })
      .catch(e => console.error('Error whil fetching report md file', e));
  }, []);

  const toggleEditorVisibility = () => {
    setEditorVisibility(!showEditor);
  };

  const updateMDString = () => {
    if (textAreaRef.current) setMDString(textAreaRef.current.value);
  };

  const renderer = {
    pre: (props: any) => {
      return props.children;
    },
    code: (props: PropsWithChildren<any>) => {
      if (props.className === 'language-json') {
        try {
          const jsonData = JSON.parse(props.children as string);
          if (Array.isArray(jsonData)) {
            return (
              <>
                {jsonData.map((data, index) => (
                  <GraphController key={index} {...data} />
                ))}
              </>
            );
          } else {
            return <GraphController {...jsonData} />;
          }
        } catch (e) {
          console.error('Error parsing JSON:', e);
          return (
            <pre>
              <code>{props.children}</code>
            </pre>
          );
        }
      }
      return (
        <pre>
          <code>{props.children}</code>
        </pre>
      );
    }
  };

  const downloadReport = () => {
    //implement download
  };

  return (
    <div className="markdownContainer">
      <div className={`markdownEditor ${showEditor ? '' : 'hidden'}`}>
        <textarea ref={textAreaRef} value={mdString}></textarea>
        <button onClick={updateMDString}>Update</button>
      </div>
      <div className="markdownRender">
        <div className="reportButtons">
          {showEditor ? (
            <FileTextFilled onClick={toggleEditorVisibility}></FileTextFilled>
          ) : (
            <FileTextOutlined
              title="Toggle Editor"
              onClick={toggleEditorVisibility}
            ></FileTextOutlined>
          )}
          <DownloadOutlined
            title="Download as PDF"
            onClick={downloadReport}
          ></DownloadOutlined>
          <></>
        </div>
        <ReactMarkdown components={renderer}>{mdString}</ReactMarkdown>
      </div>
    </div>
  );
};

export default MDReport;
